<script setup lang="ts">
import GiftlyV3Image from '@consumer/components/GiftlyV3Image.vue'
import type { RecipientGift, RedemptionCard } from '@consumer/types/serializers'
import { useCardSession } from '@consumer/composables/card_management/utils'

const { gift, redemptionCard } = defineProps<{
  gift?: RecipientGift
  redemptionCard?: RedemptionCard
}>()

if (redemptionCard) {
  useCardSession({ card: toRef(redemptionCard) })
}
</script>

<template>
  <div class="flex flex-col items-center">
    <GiftlyImage v-if="gift?.giftlyVersion === 3 || gift?.giftlyVersion === 2" :gift="gift" class="w-full"/>
    <GiftlyV3Image v-else-if="gift?.giftlyVersion !== 3 && !gift?.giftlyImageUrl" :gift="gift!" class="w-full"/>
    <img v-else-if="gift?.giftlyImageUrl" :src="gift.giftlyImageUrl" class="w-full">
  </div>
</template>
<style scoped>
.card-number-toggle {
  border: 2px solid theme("colors.primary.base");
  height: 30px;
  width: 100%;
}
</style>
